var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'note',
  { 'note__is-mine': !_vm.isResponse },
  ]},[_c('div',[_vm._t("avatar")],2),_c('div',{staticClass:"note__message"},[_c('div',{staticClass:"note__text"},[_vm._t("default")],2),_c('div',{staticClass:"note__date"},[_vm._t("date")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }